import { IconFont } from '@lighthouse/bui'
import styled from 'styled-components'

export const Container = styled.div``

export const TypeName = styled.div`
    color: var(--color-gray-500);
    font-size: 10px;
    font-weight: var(--font-weight-normal);
    line-height: 20px;
    margin-bottom: 4px;
`

export const FieldList = styled.div`
    /* padding-bottom: 4px; */
`

export const FieldItem = styled.div<{ left?: boolean }>`
    height: 28px;
    background: #eceff4;
    border-radius: 4px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    justify-content: ${({ left }) => (left ? 'flex-start' : 'space-between')};
    gap: 4px;
`

export const FieldItemIcon = styled.div``

export const Icon = styled(IconFont)`
    font-size: 12px;
    color: var(--color-gray-400);
`

export const FieldItemTitle = styled.div`
    color: var(--color-gray-600);
    font-size: 12px;
    font-weight: 400;
    margin-left: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const FieldItemRightTitle = styled.div`
    color: var(--color-gray-600);
    font-size: 12px;
    white-space: nowrap;
`
